import { createSlice } from "@reduxjs/toolkit";

import { clearStore } from "actions/initialization";

const initialState = {
  id: localStorage.getItem("micId") || "default",
  name: localStorage.getItem("micName") || "default",
  isAvailable: false,
  isRecording: false,
};

const microphoneSlice = createSlice({
  name: "microphone",
  initialState,
  reducers: {
    microphoneSet(state, action) {
      const { micId, micName } = action.payload;
      state.id = micId;
      state.name = micName;
    },
    microphoneSetAvailable(state, action) {
      state.isAvailable = action.payload;
    },
    microphoneSetRecording(state, action) {
      state.isRecording = action.payload;
    },
  },
  extraReducers: (builder) => builder.addCase(clearStore, () => initialState),
});

export const actions = microphoneSlice.actions;

export default microphoneSlice.reducer;
